<template lang="html">
<section class="LokallagFinder">
  <div class="container">
    <div class="columns">
      <div class="column is-8-widescreen is-offset-2-widescreen is-10-tablet is-offset-1-tablet">
        <div class="LokallagFinderBox">
          <h3 class="LokallagFinder-title">{{title}}</h3>
          <div class="Lokallagsdropdown">
            <button class="Button LokallagFinder-button" v-on:click="toggleDropdown">
              Finn ditt lokallag
              <icon name="chevron-down"></icon>
            </button>
            <transition name="fade">
              <div class="LokallagFinder-dropdownContent" v-show="showDropdown">
                <ul>
                  <li v-for="chapter in chapters">
                    <a class="LokallagFinder-link" :class="chapter.county ? 'Ikke-fylke' : 'Fylke'" :href="chapter.slug.current">
                      {{chapter.title}}
                    </a>
                  </li>
                </ul>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/chevron-down'
import sanityQuery from '@/sanityQuery'

export default {
  props: ['title'],
  components: {
    Icon
  },
  data () {
    return {
      chapters: [],
      showDropdown: false
    }
  },
  created () {
    var query = `*[_type == "lag" && !(_id in path "drafts.**")] | order(title asc)  [0...200]{title, slug,  "county": county->{..., title, slug}}`
    sanityQuery(query)
      .then(result => {
        var chapters = result
        var returnChapters = []
        // Reorder the result according to counties. First find county, then find all chapter which belong to the county
        for (var chapter of chapters) {
          if (!chapter.county) {
            returnChapters.push(chapter)
            for (var _chapter of chapters) {
              if (_chapter.county) {
                if (_chapter.county.title === chapter.title) {
                  returnChapters.push(_chapter)
                }
              }
            }
          }
        }
        this.chapters = returnChapters
      })
  },
  methods: {
    toggleDropdown () {
      this.showDropdown = !this.showDropdown
      console.log(this.showDropdown)
    }
  }
}
</script>

<style lang="css">
.fade-enter-active, .fade-leave-active {
  transition: all .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>



// WEBPACK FOOTER //
// src/components/ChapterDropdown.vue